import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translate(-50%, 20px);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
`

const slideDown = keyframes`
  from {
    opacity: 1;
    transform: translate(-50%, 0);
  }
  to {
    opacity: 0;
    transform: translate(-50%, 20px);
  }
`

export const Container = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isExiting',
})<{ isExiting: boolean }>`
  position: fixed;
  bottom: 48px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 24px 12px 12px;
  background-color: #ffffff;
  border: 1px solid #e4e5e7;
  border-radius: 9999px;
  box-shadow: 0 2px 24px rgba(0, 0, 0, 0.4);
  white-space: nowrap;
  pointer-events: none;
  z-index: 9999;
  animation: ${({ isExiting }) => (isExiting ? slideDown : slideUp)} 0.3s ease forwards;
`

export const EnergyBadge = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 22.4px;
  background-color: #ffc100;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

export const Message = styled.p`
  font-size: 15px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.075px;
  color: #3f4145;
`
